jQuery(function ($) {
  var activeTooltip = null;

  $(document).on("click", ".answer-tooltip", function (e) {
    e.preventDefault();

    var id = $(this).data("id");
    var type = $(this).data("type");
    var clickedElement = $(this);

    var url = "/api/anwertooltip?id=" + id;

    if (type === 'emb') {
      url+= '&type=emb';
    }

    const settings = {
      url: url,
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
      },
    };

    $.ajax(settings).done(function (response) {
      var data = response;

      function getFirstElementTag(htmlString) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlString;
        var firstElement = tempDiv.querySelector("*");
        return firstElement ? firstElement.outerHTML : "";
      }

      if (activeTooltip !== null) {
        activeTooltip.remove();
        activeTooltip = null;
      }

      var tooltip = $('<div class="tooltip-answer"></div>');

      var HTML = '<div class="tooltip-content">';

      commentsText = $("<div>").html(data.comments).text();

      if (
        data.comments !== null &&
        commentsText !== "" &&
        /^\s*$/.test(commentsText) === false
      ) {
        HTML += "<b>Comments:</b>";
        HTML += '<div class="mb-1">';

        if (getFirstElementTag(data.comments).length > 0) {
          HTML += getFirstElementTag(data.comments);
        } else {
          HTML += data.comments;
        }

        HTML += "</div>";
      }

      sourceText = $("<div>").html(data.source).text();

      if (
        data.source !== null &&
        sourceText !== "" &&
        /^\s*$/.test(sourceText) === false
      ) {
        HTML += "<b>Source:</b>";
        HTML += '<div class="mb-1">';

        if (type === 'emb') {
          HTML += data.source;
        } else {
          if (getFirstElementTag(data.source).length > 0) {
            HTML += getFirstElementTag(data.source);
          } else {
            HTML += data.source;
          }
        }

        HTML += "</div>";
      }

      if (data.permalink !== null) {
        HTML += '<a href="' + data.permalink + '" target="_blank">Read More</a>';
      }

      HTML += "</div>";

      var tooltipContent = $(HTML);

      tooltipContent.find("a").attr("target", "_blank");

      tooltip.append(tooltipContent);

      var tooltipLeft =
        clickedElement.offset().left +
        clickedElement.outerWidth() / 2 -
        tooltip.outerWidth() / 2 -
        28;
      tooltip.css({ left: tooltipLeft });

      tooltip.appendTo(document.body);
      var tooltipHeight = tooltip.outerHeight();

      var tooltipTop = clickedElement.offset().top - tooltipHeight - 10;
      tooltip.css({ top: tooltipTop });

      tooltip.remove();

      $(document.body).append(tooltip);
      activeTooltip = tooltip;

      tooltip.find("a").css("color", "#f38336");
    });

    $(document).on("click", function (event) {
      if (
        !$(event.target).closest(".tooltip").length &&
        !$(event.target).is(".answer-tooltip")
      ) {
        $(".tooltip-answer").remove();
        activeTooltip = null;
      }
    });
    $(".table-container").scroll(function () {
      $(".tooltip-answer").remove();
      activeTooltip = null;
    });
    $(".block-tema-content").scroll(function () {
      $(".tooltip-answer").remove();
      activeTooltip = null;
    });
  });

  var activeTooltip = null;

  $(".emb-tooltip").on("click", function (e) {
    e.preventDefault();

    var id = $(this).data("id");
    var property = $(this).data("property");
    var clickedElement = $(this);

    const settings = {
      url:
        "/api/embtooltip?id=" +
        id +
        "&property=" +
        encodeURIComponent(property),
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
      },
    };

    $.ajax(settings).done(function (response) {
      var data = response;

      function getFirstElementTag(htmlString) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlString;
        var firstElement = tempDiv.querySelector("*");
        return firstElement ? firstElement.outerHTML : "";
      }

      if (activeTooltip !== null) {
        activeTooltip.remove();
        activeTooltip = null;
      }

      var tooltip = $('<div class="tooltip-emb"></div>');
      var tooltipContent = $(
        '<div class="tooltip-content"><b>Comments:</b>' +
          getFirstElementTag(data.comments) +
          "<br><br><b>Source:</b>"
      );
      tooltip.append(tooltipContent);

      var sourceParagraph = $("<p>" + getFirstElementTag(data.source) + "</p>");
      sourceParagraph.find("a").attr("target", "_blank");
      tooltipContent.append(sourceParagraph);

      var tooltipLeft =
        clickedElement.offset().left +
        clickedElement.outerWidth() / 2 -
        tooltip.outerWidth() / 2 -
        28;
      tooltip.css({ left: tooltipLeft });

      tooltip.appendTo(document.body);
      var tooltipHeight = tooltip.outerHeight();

      var tooltipTop = clickedElement.offset().top - tooltipHeight - 10;
      tooltip.css({ top: tooltipTop });

      tooltip.remove();

      $(document.body).append(tooltip);
      activeTooltip = tooltip;

      tooltip.find("a").css("color", "#f38336");
    });

    $(document).on("click", function (event) {
      if (
        !$(event.target).closest(".tooltip").length &&
        !$(event.target).is(".emb-tooltip")
      ) {
        $(".tooltip-emb").remove();
        activeTooltip = null;
      }
    });

    $(".table-container").scroll(function () {
      $(".tooltip-emb").remove();
      activeTooltip = null;
    });
    $(".block-tema-content").scroll(function () {
      $(".tooltip-emb").remove();
      activeTooltip = null;
    });
  });
});
